mtl.alloy.factory.gtmEvent = (function($) {
    'use strict';

    /**
     * Return the event factory function.
     */
    return function(element, event) {

        var dataLayer = window.dataLayer;
        if (!dataLayer) {
            return;
        }

        if (!event || !event.event) {
            return;
        }

        dataLayer.push(event);

    };

}(jQuery));
